import { setAuthCheck } from '@lingoda/http';
import { getAuthCheck } from './utils';

export default () => {
    setAuthCheck(getAuthCheck);
};
